export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_05.44476eb9.jpg";